import { Outlet } from "react-router-dom";

export default function LoginLayout() {
    return (

        <div>
            <header>

                <h1> TOP  - Login Layout </h1>
            </header>

            <main style={{height: "100%"}}>
                <Outlet />
            </main>

            <footer> <h1> footer - Login Layout </h1></footer>
        </div>
    )
}